import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { ConsignmentStock, EMasterState } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsConsignmentStocksEditComponent } from './products-consignment-stocks-edit/products-consignment-stocks-edit.component';
import { ProductsConsignmentStocksAddComponent } from './products-consignment-stocks-add/products-consignment-stocks-add.component';

@Component({
    selector: 'app-products-consignment-stocks',
    templateUrl: './products-consignment-stocks.component.html',
    styleUrls: ['./products-consignment-stocks.component.css'],
    standalone: false
})
export class ProductsConsignmentStocksComponent implements OnInit {
  config?: IGenericCrudConfiguration<ConsignmentStock>;

  constructor(private api: MasterApiService) { }

  async ngOnInit(): Promise<void> {
    var companyId = this.api.auth.userValue?.lastCompanyId;
    const organizations = await firstValueFrom(this.api.resources.organization.organizations.getAll({ companyId: companyId, stateId: EMasterState.Active }));
    this.config = {
      entityFields: {
        description: { isLink: true },
        reference: { isLink: true, dataType: 'code' },
        date: { dataType: 'date' },
        organizationId: {
          lookup: {
            dataSource: organizations,
            displayExpr: 'legalName',
            valueExpr: 'id',
          }
        },
      },
      name: this.api.resources.product.consignmentStocks.resourceName,
      resource: this.api.resources.product.consignmentStocks,
      editComponent: {
        component: ProductsConsignmentStocksEditComponent,
        inputPrms: {
          organizations: organizations
        }
      },
      createComponent: {
        component: ProductsConsignmentStocksAddComponent,
        inputPrms: {
          organizations: organizations
        }
      },      
    };
  }
}
